import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IKnmListFilterRaw } from '../interfaces/IKnmListFilterRaw';
import { IKnmListFilterParams } from '../interfaces/IKnmListFilterParams';

export async function fetchKnmFilters(): Promise<IFilterResult[]> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();
  const version = lawInterface === LawInterfacesEnum.FZ_248 ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP;

  params.set('version', String(version));

  return apiGet<IFilterResult[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm?${params}`);
}

export async function fetchKnmFilterById(id: number): Promise<IKnmListFilterRaw> {
  return apiGet<IKnmListFilterRaw>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm/${id}`);
}

export async function createKnmFilter(data: IKnmListFilterRaw): Promise<IFilterResult> {
  const lawInterface = getLawInterfaceFromStorage();
  const version = lawInterface === LawInterfacesEnum.FZ_248 ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP;
  const knmFilter = { ...data, version };

  return apiPost<IFilterResult>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm`,
    body: knmFilter,
  });
}

export async function updateKnmFilter(id: number, data: IKnmListFilterRaw): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm/${id}`, data);
}

export async function deleteKnmFilter(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/${id}`);
}

export async function fetchKnmListByPlanFilters(): Promise<IFilterResult[]> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();
  const version = lawInterface === LawInterfacesEnum.FZ_248 ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP;

  params.set('version', String(version));

  return apiGet<IFilterResult[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm-plan/knm-list?${params}`,
  );
}

export async function fetchKnmListByPlanFilterById(id: number): Promise<IKnmListFilterRaw> {
  return apiGet<IKnmListFilterRaw>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm-plan/knm-list/${id}`);
}

export async function createKnmListByPlanFilter(data: IKnmListFilterRaw): Promise<IFilterResult> {
  const lawInterface = getLawInterfaceFromStorage();
  const version = lawInterface === LawInterfacesEnum.FZ_248 ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP;
  const filter = { ...data, version };

  return apiPost<IFilterResult>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm-plan/knm-list`,
    body: filter,
  });
}

export async function updateKnmListByPlanFilter(id: number, data: IKnmListFilterRaw): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/knm-plan/knm-list/${id}`, data);
}

export async function exportKnmList(
  format: ExportFormatsEnum,
  filter: IKnmListFilterParams | null,
  columns: ITableColumn<IKnmRaw>[],
): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/export?${params}`,
    body: {
      ...filter,
      /**
       * Соответствует правилу отображения таблицы (Table.tsx): колонка выбрана,
       * если только isSelected !== false. Простая проверка на истинность отбросит
       * стандартные колонки (isSelected === undefined) при первой загрузке
       * и отправит пустой массив requiredColumns.
       */
      requiredColumns: columns.filter(col => col.isSelected !== false).map(col => col.id),
    },
  });
}
